<template>
  <div class="container">
    <iframe :src="pdfurl" style="width:100vw;height: 100vh;"></iframe>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
	  name: 'openpdf',   
	  data(){
	  		return{			
	  		    pdfurl :''
	  		}  	 
		},
    created(){		
			this.pdfurl = this.$route.query.pdfurl
      console.log(this.pdfurl,'pdf')      
		},
	  }
</script>

<style scoped>
.container {
  font-family: PingFang SC;
  width: 100%;
  height: 100%;
}
</style>